namespace advisorop.services {
    "use strict";

    // Who is asking. Advisors and servicers get the same case screens off two controllers -
    // the advisor one narrows to the signed-in advisor, the servicer one never does - so the
    // only thing that changes between them is the route the request goes to.
    export type SalesforceCaseScope = "advisor" | "servicer";

    export class SalesforceCaseApi {

        static $inject = ["$http"];
        constructor(private $http: ng.IHttpService) {
        }

        private base(scope: SalesforceCaseScope): string {
            return scope === "servicer" ? "/api/servicer/salesforce" : "/api/advisor";
        }

        // Every case the caller is entitled to. status is "open" (the default), "closed" or
        // "all". Advisors additionally choose whether to narrow to their own cases; servicers
        // always see the whole org, so there is nothing to pass.
        getCases(scope: SalesforceCaseScope, status: string = "open", filterByAdvisors: boolean = false)
            : ng.IHttpPromise<domains.ISalesforceCaseResult> {

            if (scope === "servicer")
                return this.$http.get(`/api/servicer/salesforce/cases?status=${status}`);

            return this.$http.get(`/api/advisor/getopencases/${filterByAdvisors}?status=${status}`);
        }

        // Cases Salesforce holds against the household itself, which is what its Related tab
        // lists. Only the advisor side has a household to scope to.
        getHouseholdCases(householdId: number, status: string = "open"): ng.IHttpPromise<domains.ISalesforceCaseResult> {
            return this.$http.get(`/api/advisor/household/${householdId}/cases?status=${status}`);
        }

        getRecordTypes(scope: SalesforceCaseScope): ng.IHttpPromise<domains.ISalesforceCaseRecordType[]> {
            return this.$http.get(`${this.base(scope)}/case/recordtypes`);
        }

        getNewForm(scope: SalesforceCaseScope, recordTypeId: string): ng.IHttpPromise<domains.ISalesforceCaseNewFormResult> {
            return this.$http.get(`${this.base(scope)}/case/newform/${recordTypeId}`);
        }

        // lookup is "contact", "user" or "household"; every match is a live Salesforce record.
        searchLookup(scope: SalesforceCaseScope, lookup: string, term: string): ng.IHttpPromise<domains.ISalesforceLookupResult[]> {
            return this.$http.get(`${this.base(scope)}/case/lookup/${lookup}`, { params: { term: term } });
        }

        createCase(scope: SalesforceCaseScope, salesforceCase: domains.ISalesforceCaseCreate)
            : ng.IHttpPromise<domains.ISalesforceCaseCreateResult> {

            return this.$http.post(`${this.base(scope)}/case/create`, salesforceCase);
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("salesforceCaseApi", SalesforceCaseApi);
}
